import DirectLogo from 'assets/svg/direct/direct.svg'
import Arrow from 'assets/svg/icon_arrow/icon_arrow-back.svg'
import KalibrasiLogo from 'assets/svg/kalibrasi/kalibrasi.svg'
import OnlineInvoiceLogo from 'assets/svg/menu-logo/online-invoice-logo.svg'
import RAgentLogo from 'assets/svg/menu-logo/r-agent-logo.svg'
import RalaliBilling from 'assets/svg/menu-logo/r-billing.svg'
import RConnectLogo from 'assets/svg/menu-logo/r-connect-logo.svg'
import RalaliCorporateBilling from 'assets/svg/menu-logo/r-corporate-billing.svg'
import RalaliPlusLogo from 'assets/svg/menu-logo/r-plus-logo.svg'
import RBizLogo from 'assets/svg/menu-logo/rbiz-logo.svg'
import PavilionLogo from 'assets/svg/pavilion/pavilion.svg'
import TenderLogo from 'assets/svg/tender/tender.svg'
import Flex from 'common/components/Flex'
import Typography from 'common/components/Typography'
import { MOBILE_WEB_URL } from 'common/constants'
import theme from 'common/theme'
import Link from 'next/link'
import styled from 'styled-components'

const ServiceList = styled(Flex)`
  width: 1103px;
  max-height: 460px;
  overflow: scroll;
  box-sizing: border-box;
  padding: 0 20px;
`

const Container = styled(Flex)`
  width: 200px;
  max-height: 350px;
  box-sizing: border-box;
`

const ServiceListItem = styled.div`
  width: 200px;
  max-height: 407px;
  box-sizing: border-box;
  padding: 18px 0;
  :first-child {
    width: 600px;
  }
  :nth-child(even) {
    border-top: 1px solid ${theme.colors.grayLighter};
  }
`

const Service = styled.a`
  display: flex;
  align-items: center;
  margin-top: 20px;
  svg {
    flex-shrink: 0;
  }
`

const services = [
  {
    title: 'SOLUSI BISNIS RALALI',
    services: [
      {
        title: 'Ralali Tender',
        short_desc:
          'Solusi untuk mencari produk yang Anda mau dengan penawaran terbaik.',
        logo: <TenderLogo />,
        href: '/solutions/tender',
      },
      {
        title: 'Ralali Pavilion',
        short_desc:
          'Solusi branding yang lebih mudah dan cepat untuk produk dan jasa Anda.',
        logo: <PavilionLogo />,
        href: '/solutions/pavilion',
      },
      {
        title: 'Ralali Direct',
        short_desc:
          'Solusi untuk mendistribusikan produk dengan cepat dan margin yang lebih tinggi.',
        logo: <DirectLogo />,
        href: '/solutions/direct',
      },
      {
        title: 'Ralali Agent',
        short_desc:
          'Solusi untuk mengiklankan usaha Anda lebih mudah dan murah.',
        logo: <RAgentLogo />,
        href: '/solutions/agent',
      },
      {
        title: 'Ralali Plus',
        short_desc:
          'Solusi untuk mendukung pertumbuhan dan cash flow bisnis Anda.',
        logo: <RalaliPlusLogo />,
        href: '/solutions/plus',
      },
      {
        title: 'Ralali Billing',
        short_desc:
          'Solusi untuk membantu segala kebutuhan pembayaran tagihan Anda.',
        logo: <RalaliBilling />,
        href: '/billing',
      },
      {
        title: 'Ralali Corporate Billing',
        short_desc:
          'Solusi kemudahan dalam mengelola pembayaran tagihan perusahaan Anda.',
        logo: <RalaliCorporateBilling />,
        href: '/billing/corporate-billing',
      },
    ],
  },
  {
    title: 'LAYANAN ENABLER',
    services: [
      {
        title: 'RBiz',
        short_desc: 'Membantu distributor online di pasar digital',
        logo: <RBizLogo />,
        href: 'https://rbiz.co.id',
      },
    ],
  },
  {
    title: 'DUKUNGAN LAYANAN UMKM',
    services: [
      {
        short_desc:
          'Menghubungkan UMKM dalam satu jaringan komunitas.',
        logo: <RConnectLogo />,
        href: 'https://ralaliconnect.com',
      },
    ],
  },
  {
    title: 'DUKUNGAN BISNIS',
    services: [
      {
        short_desc:
          'Platform digital yang menawarkan kemudahan jasa kalibrasi untuk keberlangsungan bisnis.',
        logo: <KalibrasiLogo />,
        href: 'https://kalibrasi.com',
      },
    ],
  },
  {
    title: 'FITUR TERBARU',
    services: [
      {
        short_desc:
          'Solusi tagihan lunas lebih cepat untuk bisnis Anda.',
        logo: <OnlineInvoiceLogo />,
        href: `${MOBILE_WEB_URL}/online-invoice`,
      },
    ],
  },
]

function BusinessSolution(): JSX.Element {
  return (
    <>
      <ServiceList flexDirection="column" flexWrap="wrap">
        {services.map((serviceGroup, groupIndex) => {
          return (
            <ServiceListItem key={String(`group-${groupIndex}`)}>
              <Typography type="blabel">
                {serviceGroup.title}
              </Typography>
              <Container flexDirection="column" flexWrap="wrap">
                {serviceGroup.services.map((service, index) => {
                  return (
                    <Link
                      href={service.href}
                      passHref
                      key={String(`service-${index}`)}
                    >
                      <Service>
                        <Flex
                          flexDirection="column"
                          margin="0 0 0 10px"
                        >
                          <>
                            {service.logo}
                            <Typography
                              type="rlead"
                              display="block"
                              marginTop={10}
                            >
                              {service.short_desc}
                            </Typography>
                            <Typography
                              type="blead"
                              marginTop={10}
                              color="redOrange"
                            >
                              <>
                                Lihat selengkapnya&nbsp;&nbsp;
                                <Arrow />
                              </>
                            </Typography>
                          </>
                        </Flex>
                      </Service>
                    </Link>
                  )
                })}
              </Container>
            </ServiceListItem>
          )
        })}
      </ServiceList>
    </>
  )
}

export default BusinessSolution
